import React from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';

import UserRow from './UserRow';
import styles from './styles.styl';

function MobileSidebar({
  visible,
  publisher,
  users,
  onPin,
  pinnedId,
  isProvider,
}) {
  return (
    <div className={cn(styles.root, { [styles.visible]: visible })}>
      <UserRow connection={publisher} isMe />
      {users.map(([id, connection]) => (
        <UserRow
          connection={connection}
          isProvider={isProvider}
          pinnedId={pinnedId}
          onPin={onPin}
          key={id}
        />
      ))}
    </div>
  );
}

MobileSidebar.propTypes = {
  visible: PropTypes.bool,
  isProvider: PropTypes.bool,
  publisher: PropTypes.object,
  users: PropTypes.array,
  onPin: PropTypes.func,
  pinnedId: PropTypes.string,
};

export default MobileSidebar;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/MobileVideo/MobileSidebar/index.jsx